<template>
	<v-card class="elevation-0">
		<v-toolbar color="blue lighten-1" dark flat>
			<v-toolbar-title>Вход</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-form>
				<v-row>
					<v-col sm="12" lg="6">
						<v-text-field
							label="Логин"
							name="username"
							prepend-icon="mdi-account"
							type="text"
							v-model="form.username"
							:error-messages="usernameErrors"
							@keyup.enter="validateForm"
							:disabled="pending"
						></v-text-field>
					</v-col>
					<v-col sm="12" lg="6">
						<v-text-field
							id="password"
							label="Пароль"
							name="password"
							prepend-icon="mdi-lock"
							type="password"
							v-model="form.password"
							:error-messages="passwordErrors"
							@keyup.enter="validateForm"
							:disabled="pending"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn text :loading="pending" color="blue lighten-1" @click="validateForm">Войти</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
	name: 'LoginForm',
	mixins: [ validationMixin ],
	data: () => ({
		form: { username:null, password:null }, pending:false, falseCredentials:false
	}),
	validations: {
		form: {
			username:{ required, minLength:minLength(3) },
			password:{ required }
		}
	},
	computed: {
		usernameErrors () {
			const errors = []
			if (!this.$v.form.username.$dirty) return errors
			!this.$v.form.username.minLength && errors.push('Минимум 3 символа')
			!this.$v.form.username.required && errors.push('Обязательное поле')
			this.falseCredentials && errors.push('Неправильный логин или пароль')
			return errors
		},
		passwordErrors () {
			const errors = []
			if (!this.$v.form.password.$dirty) return errors
			!this.$v.form.password.required && errors.push('Обязательное поле')
			this.falseCredentials && errors.push('Неправильный логин или пароль')
			return errors
		}
	},
	methods: {
		getValidationClass(fieldName){
			let field = this.$v.form[fieldName]
			if(field) return { 'md-invalid': (field.$invalid && field.$dirty) || (fieldName == 'password' && this.falseCredentials) }
		},
		validateForm(){
			this.$v.$touch()
			if(!this.$v.$invalid){
				this.pending = true
				this.sendFormData().then(res => {
					this.$eventBus.$emit('user_logged_in', res.data.token)
					this.pending = false
					this.falseCredentials = false
				}, rej => {
					this.pending = false
					this.falseCredentials = true
				})
			}
		},
		sendFormData(){
			return new Promise((res, rej) => {
				this.$api.post('auth/login/', this.form)
				.then(function(response) {
					res(response)
				}).catch(error => rej(error));
			})
		}
	}
}
</script>
